export default __webpack_public_path__ + "static/media/input-line.899e7f44.svg";